export const ROOT_PATH = '/packages/incoming' as const;
export const ERROR_PATH = '/error' as const;
